import secondaryComponents from "../../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import globalStyles from "../../../../../../assets/styles/base/globalPage.module.scss";
import { BackButton } from "../../../../../../components/primaryComponents";
import { GoodsReceivedForm } from "../../../../../../components/secondaryComponents/GoodsReceived";
import { useEditGoodsReceived } from "./useEditGoodsReceived";

export const EditGoodsReceived = () => {
  const { isLoading, GRDetails } = useEditGoodsReceived({});

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Update Goods Received Notes"
      description="Update goods received that was created in the past."
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles.pageColumnGaps}`}
        >
          <div className="d-flex align-items-center">
            <BackButton />
            <h4 className="ml-2 mb-0">
              <span className="gray--text">GRN Number: </span>{" "}
              {GRDetails?.gr_number}
            </h4>
          </div>

          <secondaryComponents.LoaderHelper
            classNames={"mt-5"}
            isLoading={isLoading}
          >
            <GoodsReceivedForm isEditMode={true} GRDetails={GRDetails} />
          </secondaryComponents.LoaderHelper>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
